import type { DocPageContent } from '../docs-content'

const page = {
  order: 4,
  slug: 'editor',
  title: 'Diseño y navegación del editor',
  description:
    'La barra de herramientas, el panel lateral de medios, el monitor de vista previa, la línea de tiempo, las propiedades y los espacios de trabajo de Edición y Color.',
  category: 'Inicio',
  related: ['concepts', 'timeline', 'keyboard-shortcuts'],
  sections: [
    {
      title: 'Las superficies principales',
      blocks: [
        {
          kind: 'list',
          items: [
            '**Barra de herramientas del editor** (arriba): Volver a Proyectos, pestañas de espacios de trabajo, especificaciones del proyecto, idioma, Ajustes, Atajos de teclado, Guardar, Exportar y la cola de renderizado.',
            '**Panel lateral de medios** (izquierda): tus recursos y herramientas de creación.',
            '**Monitor de vista previa**: el fotograma actual con superposiciones, máscaras, formas de onda (scopes) y controles de reproducción.',
            '**Línea de tiempo** (abajo): pistas, clips, marcadores y herramientas de edición.',
            '**Panel de propiedades**: edita el clip o los clips que tengas seleccionados.',
          ],
        },
      ],
    },
    {
      title: 'Las pestañas del panel lateral de medios',
      blocks: [
        {
          kind: 'table',
          headers: ['Pestaña', 'Contenido'],
          rows: [
            [
              'Medios',
              'Recursos importados, información de medios, proxies, transcripciones, subtítulos, clips compuestos, controles de medios faltantes',
            ],
            ['Texto', 'Clips de texto de plantillas de un solo tramo y de varios tramos'],
            ['Formas', 'Elementos de formas generadas'],
            ['Efectos', 'Efectos por GPU para el clip seleccionado'],
            ['Transiciones', 'Transiciones para arrastrar sobre los cortes'],
            ['IA', 'Texto a voz y generación de música local'],
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: 'Un botón independiente de **Editor de fotogramas clave** expande el panel lateral hacia el editor de animación.',
        },
      ],
    },
    {
      title: 'Espacios de trabajo',
      blocks: [
        {
          kind: 'list',
          items: [
            'El espacio de trabajo **Edición** (`Alt+1`) es el diseño de corte predeterminado para organizar, recortar, texto, formas, efectos, transiciones y vista previa.',
            'El espacio de trabajo **Color** (`Alt+2`) se centra en la corrección de color, con ruedas de color, curvas y formas de onda (scopes) para el clip seleccionado.',
            'El espacio de trabajo **Animar** abre los preajustes de movimiento y el gráfico de fotogramas clave para el clip seleccionado; consulta [Espacio de trabajo Animar](animate).',
            'Cambia de espacio de trabajo desde las pestañas de la barra de herramientas central; Edición y Color también tienen atajos de teclado.',
          ],
        },
      ],
    },
    {
      title: 'Obtener ayuda y mantenerte seguro',
      blocks: [
        {
          kind: 'list',
          items: [
            'Abre **Ajustes** para las preferencias generales, de línea de tiempo, de IA y de almacenamiento.',
            'Abre **Atajos de teclado** para buscar comandos, reasignar teclas e importar o exportar preajustes.',
            'Guarda con frecuencia con `Ctrl+S`; el autoguardado también puede ejecutarse en un intervalo que definas en Ajustes.',
            'Deshacer y Rehacer (`Ctrl+Z` y `Ctrl+Shift+Z`) cubren las ediciones de la línea de tiempo cuando algo sale mal.',
          ],
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page
